export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_38-7f14057d654a5cc2f187b908202e315f.jpg";